import React from "react";
import { Location } from "../Location";
import { ConsultantEditor } from "@consultants/ConsultantEditor/ConsultantEditor";

interface Params {
  consultantId: string;
}

export class ConsultantEditorLocation extends Location<Params> {
  constructor(consultantId: string) {
    super({ consultantId });
  }

  render(): React.ReactElement<any> {
    return <ConsultantEditor consultantId={this.params.consultantId} />;
  }

  toURI() {
    const { consultantId } = this.params;
    return `/consultants/${consultantId || "new"} `;
  }
}
